import PropTypes from 'prop-types'

import { iso8601PropType } from '../common/iso-8601-prop-type'

export const optiDriveProfilePropType = PropTypes.shape({
    optidriveProfileId: PropTypes.string,
    name: PropTypes.string,
    isDefault: PropTypes.bool,
    isGlobal: PropTypes.bool,
    optiDriveKpis: PropTypes.arrayOf(
        PropTypes.shape({
            kpiId: PropTypes.number,
            kpiWeight: PropTypes.number
        })
    ),
    drivers: PropTypes.arrayOf(PropTypes.string),
    creationTime: iso8601PropType,
    updateTime: iso8601PropType
})
